import { FC } from "react";
import { useTranslation } from "react-i18next";
import useStyles from "./styles";

type props = {
  isActive: boolean;
};

export const CustomLoader: FC<props> = ({ isActive }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  if (!isActive) return null;

  const label = t("common.loading", "Loading...");

  return (
    /*
     * `role="alert"` + `aria-busy` announce the wait to a screen reader; the
     * previous markup was a pair of undescribed <div>s, so assistive tech saw
     * the page simply stop responding.
     */
    <div
      className={classes.container}
      role="alert"
      aria-live="assertive"
      aria-busy="true"
    >
      <div className={classes.spinner} aria-hidden="true" />
      <p className={classes.label}>{label}</p>
    </div>
  );
};
